export const FORM_NAME = 'ACTIVITY_TAG_FORM'
export const GET_ENTITY_BY_ID = `${FORM_NAME}_GET_ENTITY_BY_ID`
export const REMOVE_ENTITY_BY_ID = `${FORM_NAME}_REMOVE_ENTITY_BY_ID`

export default {
  FORM_NAME,
  GET_ENTITY_BY_ID,
  REMOVE_ENTITY_BY_ID,
}
